import React from 'react';
import moment from 'moment';
import { Row, Col, Dropdown, Form, Checkbox } from 'antd';
import { CheckCircleOutlined, DeleteOutlined, EditOutlined, EllipsisOutlined } from '@ant-design/icons';

import { TaskName } from './TaskName';
import { AddButton } from './AddButton';
import { DueDateDropdown } from './DueDateDropdown';
import { useTasksItem } from './_hooks/useTasksItem';
import { UserAvatar } from '@/components/ui/UserAvatar';
import { ResponsibleDropdown } from './ResponsibleDropdown';
import { Task, TaskType } from '@/components/ActionPlan/types';

import * as S from './styles';


interface SelectUser {
	label: string;
	value: string;
}

interface TaskItemProps {
	index: number;
	data: Task;
	users: SelectUser[];
}

export function TaskItem({ index, data, users }: Readonly<TaskItemProps>): JSX.Element {
	const { form, editing, handleEditTask, handleCompleteTask, confirmUpdateTask, filterUserName, handleDeleteTask } =
		useTasksItem({ index, users });

	const dropdownOptions = [
		{
			key: 'edit',
			label: (
				<div style={{ color: '#2F54EB', fontSize: '1.5rem' }}>
					<EditOutlined />
				</div>
			),
			onClick: () => handleEditTask(data)
		},
		{
			key: 'delete',
			label: (
				<div style={{ color: '#E74150', fontSize: '1.5rem' }}>
					<DeleteOutlined />
				</div>
			),
			onClick: handleDeleteTask
		}
	];

	function filterDropdownOptions(): any[] {
		if (data.type === TaskType.ENGINEERING || data.type === TaskType.ADMINISTRATIVE) {
			return [dropdownOptions[0]];
		}

		return dropdownOptions;
	}

	if (editing) {
		return (
			<Form form={form}>
				<Row justify="space-between" align="middle" style={{ marginBottom: '15px' }}>
					<Col span={20}>
						<TaskName fieldName="action_plan_task_name" style={{ marginBottom: 0 }} />
					</Col>
					<Col>
						<DueDateDropdown fieldName="action_plan_task_due_date" />
					</Col>
					<Col>
						<ResponsibleDropdown fieldName="action_plan_task_responsible" options={users} />
					</Col>
					<Col>
						<AddButton type="primary" icon={<CheckCircleOutlined />} onClick={confirmUpdateTask} />
					</Col>
				</Row>
			</Form>
		);
	}
	return (
		<Row justify="space-between" align="middle">
			<Col span={18} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
				{data.id && <Checkbox onChange={() => handleCompleteTask(data.id!)} checked={data.is_completed} />}
				<S.InputLabel isCompleted={data.is_completed} style={{ marginBottom: 0 }}>
					{data.title}
				</S.InputLabel>
			</Col>
			<Col span={6}>
				<Row>
					<Col span={13} style={{ display: 'flex', justifyContent: 'center' }}>
						<span style={{ fontSize: '0.8rem' }}>
							{data.due_date ? moment(data.due_date).format('DD/MM/YYYY') : '-'}
						</span>
					</Col>
					<Col span={8} style={{ display: 'flex', justifyContent: 'center' }}>
						<UserAvatar
							name={filterUserName(data.responsible_user_id)}
							size="small"
							style={{ marginRight: '10px', marginBottom: '3px' }}
						/>
					</Col>
					<Col span={2}>
						<Dropdown
							trigger={['click']}
							menu={{ items: filterDropdownOptions() }}
							placement="bottomRight"
							disabled={data.is_completed}
						>
							<S.TransparentButton style={{ fontSize: 25 }}>
								<EllipsisOutlined />
							</S.TransparentButton>
						</Dropdown>
					</Col>
				</Row>
			</Col>
		</Row>
	);
}
